import { AfterViewInit, Component, ContentChildren, Input, QueryList } from '@angular/core';
import { DxCheckBoxComponent, DxDateBoxComponent, DxDropDownBoxComponent, DxNumberBoxComponent, DxRadioGroupComponent, DxSelectBoxComponent, DxTagBoxComponent, DxTextAreaComponent, DxTextBoxComponent } from 'devextreme-angular';
import { Utils } from '@core/helpers/Utils';
import { IBaseComponent } from '@base/component/IBaseComponent';
import { CustomizationService } from '@m4u-angular/core/framework/customization-service';
import { ScreenService } from '@m4u-angular/core/framework/screen.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'm4u-field',
    templateUrl: './fieldform.component.html',
    styleUrls: ['./fieldform.component.scss'] 
})
export class FieldFormComponent implements AfterViewInit {
    @Input() Name: string;
    @Input() IsHideLabel: boolean;
    @Input() IsRemoveLabel: boolean;
    @Input() public Component: IBaseComponent;
    @Input() SearchText: string = null;

    @ContentChildren(DxSelectBoxComponent) private ctlSelectBoxes: QueryList<DxSelectBoxComponent>;
    @ContentChildren(DxTextBoxComponent) private ctlTextBoxes: QueryList<DxTextBoxComponent>;
    @ContentChildren(DxTextAreaComponent) private ctlTextAreas: QueryList<DxTextAreaComponent>;
    @ContentChildren(DxNumberBoxComponent) private ctlNumberBoxes: QueryList<DxNumberBoxComponent>;
    @ContentChildren(DxDateBoxComponent) private ctlDateBoxes: QueryList<DxDateBoxComponent>;
    @ContentChildren(DxCheckBoxComponent) private ctlCheckBoxes: QueryList<DxCheckBoxComponent>;
    @ContentChildren(DxTagBoxComponent) private ctlTagBoxes: QueryList<DxTagBoxComponent>;
    @ContentChildren(DxRadioGroupComponent) private ctlRadioGroup: QueryList<DxTagBoxComponent>;
    @ContentChildren(DxDropDownBoxComponent) private ctlDropDownBoxes: QueryList<DxDropDownBoxComponent>;

    public IsHide: boolean;
    public IsFocused: boolean;

    private m_bInitComplete: boolean;
    private m_bEventAttached: boolean;

    constructor(private customizationService: CustomizationService, private screen: ScreenService, public sanitizer: DomSanitizer) { }

    //Set template that highlights the typed in item, shows the value, and enables search by value
    private _Label: string;
    get Label(): string {
        return this._Label; 
    }
    @Input() set Label(value: string) {
        const sPrev = this._Label;
        this._Label = value;
        if (this.m_bInitComplete) this.SetPlaceHolder(sPrev);
    }

    //Set placeholder
    private SetPlaceHolder(sPrev: string) {
        //Get relevant editor control
        const control = this.GetEditorControl();
        if (control == undefined) return;
        if (control instanceof DxCheckBoxComponent) {
            if (this.screen.IsMobile() && this.IsHideLabel == null) this.IsHideLabel = true;
            return;
        }
        if (control instanceof DxTextAreaComponent && control.stylingMode === 'outlined') {
            this.IsHideLabel = false;
            return;
        }

        //Handle cases when placeholder is set explicitely on the editor itself
        const sPlaceHolder = control.instance.option('placeholder');
        if (Utils.IsEmpty(sPlaceHolder) || sPlaceHolder == sPrev) control.instance.option('placeholder', this.Label);

        //Hide the label
        this.IsHideLabel = Utils.IsEmpty(control.instance.option("value")) && Utils.IsEmpty(control.instance.option("mask"));

        //Attach event
        if (!this.m_bEventAttached) {
            this.m_bEventAttached = true;
            control.instance.on('valueChanged', (e) => this.IsHideLabel = Utils.IsEmpty(e.value) && Utils.IsEmpty(control.instance.option("mask")));
            control.instance.on('focusIn', (e) =>
            { 
                this.IsHideLabel = false;
                this.IsFocused = true;
            });
            control.instance.on('focusOut', (e) =>
            {
                this.IsHideLabel = Utils.IsEmpty(e.component.option("value")) && Utils.IsEmpty(control.instance.option("mask"));
                this.IsFocused = false;
            });
        }
    }

    ngAfterViewInit() {
        this.m_bInitComplete = true;
        setTimeout(() => this.SetPlaceHolder(this.Label), 300);
    }

    public SetFieldDefaultValue() {
        this.customizationService.SetFieldDefaultValue(this);
    }

    //Configures the customizations
    public SetFieldCustomizations() {
        this.customizationService.SetFieldCustomizations(this);
    }

    //Return the relevant control that we need to apply to
    GetEditorControl(): any {
        for (const controls of this.Controls()) {
            if (controls != undefined && controls.length == 1) return controls.first;
        }
    }

    //Return all control types
    protected Controls(): QueryList<any>[] {
        return [
            this.ctlSelectBoxes,
            this.ctlTextBoxes,
            this.ctlTextAreas,
            this.ctlNumberBoxes,
            this.ctlDateBoxes,
            this.ctlCheckBoxes,
            this.ctlTagBoxes,
            this.ctlRadioGroup,
            this.ctlDropDownBoxes
        ];
    }

}
